export default __webpack_public_path__ + "static/media/sheet_thumb15_teamlist@2x.86bbff46.png";